import { useState, useCallback } from 'react';
import { AlertColor } from '@mui/material';

export interface NotificationAction {
  label: string;
  onClick: () => void;
}

export interface NotificationState {
  id?: string;
  open: boolean;
  message: string;
  severity: AlertColor;
  action?: NotificationAction;
}

export interface ShowNotificationOptions {
  action?: NotificationAction;
  id?: string;
}

export const useNotification = () => {
  const [notification, setNotification] = useState<NotificationState>({
    open: false,
    message: '',
    severity: 'info',
  });

  const showNotification = useCallback(
    (
      message: string,
      severity: AlertColor = 'info',
      options?: ShowNotificationOptions
    ) => {
      setNotification({
        open: true,
        message,
        severity,
        id: options?.id,
        action: options?.action,
      });
    },
    []
  );

  const hideNotification = useCallback((targetId?: unknown) => {
    setNotification((prev) => {
      if (typeof targetId === "string" && prev.id && prev.id !== targetId) {
        return prev;
      }
      return { ...prev, open: false };
    });
  }, []);

  return {
    notification,
    showNotification,
    hideNotification,
  };
};
 